export type CoreFieldMaps = Record<string, string[] | null>;
export type AdditionalField = { name: string; path: string };
export type Condition = { field: string; op: string; value: string };

export type ParseResult = {
    maps: CoreFieldMaps;
    conds: Condition[];
    addl: AdditionalField[];
    literalMaps: Record<string, string>;
    complexFields: Record<string, string>;
    isFullyParseable: boolean;
    rawJq: string;
};

export const OPS = [
    { v: "not_null", labelKey: "is not null" },
    { v: "is_null", labelKey: "is null" },
    { v: "equals", labelKey: "equals" },
    { v: "not_equals", labelKey: "≠" },
    { v: "gt", labelKey: ">" },
    { v: "lt", labelKey: "<" },
    { v: "contains", labelKey: "contains" },
];
